<template>
  <b-modal v-model="showModal" centered header-class="custom-modal-header" hide-footer>
    <template #modal-title>
      <p class="text-header">Choose Platform</p>
    </template>
    <div class="d-flex justify-content-center py-3">
      <b-button
        variant="platform"
        @click="handleLINE()"
        :disabled="platformIdList.includes(1)"
        >
        <img src="@/assets/images/icons/line.png"
      /></b-button>
      <b-button
        variant="platform"
        :disabled="platformIdList.includes(4)"
        @click="handleFB()"
        class="mx-3"
        >
        <img src="@/assets/images/icons/facebook.png" />
      </b-button>
      <b-button
        variant="platform"
        :disabled="platformIdList.includes(5)"
        @click="handleIG()"
      >
        <img src="@/assets/images/icons/instagram.png" />
      </b-button>
    </div>
    <ModalSelectPageFacebook ref="modalSelectPageFacebook" :v="$v.selectedPage" :pages="pages" @handleSelectedPage="handleSelectedPage" />
  </b-modal>
</template>

<script>
import ModalSelectPageFacebook from "./ModalSelectPageFacebook.vue";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ModalCreatePlatform",
  components: {
    ModalSelectPageFacebook
  },
  props: {},
  validations() {
    return {
      selectedPage: {
        id: { required },
      },
    };
  },
  data: function() {
    return {
      appId: this.$facebookAppId,
      secret: this.$facebookSecret,
      version: "v12.0",
      selectPlatformId: 1,
      selectedPage: {
        url: null,
        name: "",
        access_token: "",
        picture: {
          data: {
            url: "",
            name: null,
            access_token: null,
            picture: null,
            id: null
          },
        },
        id: "",
        instagram_business_account: {
          id: null
        }
      },
      pages: [],
      profile: {},
      authorized: false,
      authResponse: null,
      connected: true,
      showModal: false,
      isShowPage: false,
      page: null,
      getPageToken: null,
      isLoading: false
    };
  },
  props: {
    platformIdList: {
      required: false,
      type: Array,
    },
  },
  async created() {

    try {
      var _this = this;
      window.fbAsyncInit = function() {
        FB.init({
          appId: _this.appId,
          cookie: true,
          xfbml: true,
          version: _this.version,
        });
        FB.getLoginStatus(({ authResponse }) => {
          console.log("getLoginStatus ", authResponse);
        });

        FB.AppEvents.logPageView();
      };

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    } catch (error) {
      console.log("connect error ", error);
    }
  },
  methods: {
    onCloseModal() {
      this.showModal = false;
    },
    handleLINE() {
      this.selectPlatformId = 1;
      this.$emit("handleLINE");
    },
    handleFB() {
      this.selectPlatformId = 4;
      let vm = this;
      FB.login(
        function(response) {
          console.log("login", response);
          vm.statusChangeCallback(response);
        },
        {
          scope:
            "email, public_profile, pages_show_list, pages_read_engagement, pages_manage_metadata, pages_messaging, pages_manage_posts, pages_manage_engagement",
          return_scopes: true,
        }
      );
    },
    handleIG() {
      this.selectPlatformId = 4;
      let vm = this;
      FB.login(
        function(response) {
          console.log("login", response);
          vm.statusChangeCallback(response);
        },
        {
          scope:
            "email, public_profile, pages_show_list, pages_read_engagement, pages_manage_metadata, pages_messaging, pages_manage_posts, pages_manage_engagement, instagram_basic, instagram_manage_messages ",
          return_scopes: true,
        }
      );
    },
    logoutFB() {
      let vm = this;
      FB.logout(function(response) {
        vm.statusChangeCallback(response);
      });
    },
    statusChangeCallback(response) {
      console.log("login", response);
      let vm = this;
      if (response.status === "connected") {
        vm.authorized = true;
        vm.authResponse = response.authResponse;
        vm.authorized = response.authResponse;
        vm.getProfileFB();
        vm.connected = true;
      } else if (response.status === "not_authorized") {
        vm.authorized = false;
      } else if (response.status === "unknown") {
        vm.profile = {};
        vm.authorized = false;
      } else {
        vm.authorized = false;
      }
    },
    getProfileFB: async function() {
      console.log("this auth fb", this.authResponse);
      let vm = this;
      await FB.api("/me?fields=name,id,email", (response) => {
        console.log("get me", response);
        FB.api(
          `/oauth/access_token?grant_type=fb_exchange_token&client_id=${vm.appId}&client_secret=${vm.secret}&fb_exchange_token=${vm.authResponse.accessToken}`,
          (res) => {
            console.log("get profile", res);
            vm.getPageToken = res.access_token;
            console.log("get page token", vm.getPageToken);
            console.log("token", vm.authResponse.accessToken);
            vm.getPages();
          }
        );
      });
    },
    async getPages() {
      await this.axios
        .post(
          `${this.$baseUrl}/livePost/facebookPage`,
          {
            psid: this.authResponse.userID,
            userToken: this.getPageToken,
          }
        )
        .then((data) => {
          if (data.result === 1) {
            this.isShowPage = false;
            this.pages = data.detail;
            this.handleModalSelectPageFacebookShow();
          } else this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message });
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
        });
    },
    handleModalSelectPageFacebookShow(){
      this.$v.selectedPage.$reset();
      this.selectedPage = {
        url: null,
        name: "",
        access_token: "",
        picture: {
          data: {
            url: "",
            name: null,
            access_token: null,
            picture: null,
            id: null
          },
        },
        id: "",
        instagram_business_account: {
          id: null
        }
      };
      this.$refs.modalSelectPageFacebook.onShowModal();
    },
    handleSelectedPage(val) {
      this.selectedPage = val

      this.$v.selectedPage.$touch();
      if (this.$v.selectedPage.$error) return;

      this.confirm();
    },
    async confirm() {
      let body = {
        id: 0,
        pageid: this.selectedPage.id,
        name: this.selectedPage.name,
        tokenfacebook: this.selectedPage.access_token,
        pictureUrl: this.selectedPage.picture.data.url,
        InstagramId: this.selectedPage.instagram_business_account.id || null
      }
      await this.axios
        .post(
          `${this.$baseUrl}/livePost/updateFacebookPage`,
          body
        )
        .then((data) => {
          console.log("update facebook page", data);
          if (data.detail == 1) {
            this.$refs.modalSelectPageFacebook.onCloseModal();
            this.$emit("reloadData");
            this.onCloseModal();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message });
          }
        }).catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
        });
    },
  },
};
</script>
